import React from 'react';
import TextField from '@mui/material/TextField';

const NumericTextField = ({
  id,
  label,
  title,
  error,
  value,
  onChange,
  disabled = false, // Default to false
}) => {
  // const FLOAT_REGEX = /^(\d+(\.\d+)?)?$/;
  const FLOAT_REGEX = /^(\d+(\.\d*)?)?$/;

  const handleChange = (e) => {
    const inputValue = e.target.value.trim();
    if (FLOAT_REGEX.test(inputValue) || inputValue === '') {
      onChange(inputValue);
    }
  };

  return (
    <TextField
      fullWidth
      required
      label={label}
      id={id}
      title={title}
      error={!!error}
      helperText={error}
      value={value}
      size='small'
      onChange={handleChange}
      InputLabelProps={{
        shrink: true,
      }}
      disabled={disabled} // Apply the disabled prop
    />
  );
};

export default NumericTextField;
